import * as React from 'react';

function SvgSignUpPhone(props) {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.635 3a1 1 0 011-1h8.667a1 1 0 011 1v14a1 1 0 01-1 1H5.635a1 1 0 01-1-1v-3.667h10.667V12H4.635V3zm6.667 12.6a1.333 1.333 0 11-2.667 0 1.333 1.333 0 012.667 0z"
        fill="#252525"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgSignUpPhone;
